<template>
  <div>
    <b-breadcrumb>
			<b-breadcrumb-item active>{{$t('historial.compras.title')}}</b-breadcrumb-item>
		</b-breadcrumb>
    <div class="card mb-3">
      <div class="card-body">
        <h6 class="sub-title"><span>{{$t('historial.compras.sub-title')}}</span></h6>
        <b-table hover :items="itemsCompraActiva" :fields="fieldCompraActiva"
         style="max-width:648px;margin:auto" :empty-text="$t('reusables.empty-text')"/>
        <div class="empty" v-show="!itemsCompraActiva.length">
          <img src="@/assets/img/empty.png">
          <p>{{$t('historial.compras.text.1')}}</p>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h6 class="sub-title"><span>{{$t('historial.compras.title')}}</span></h6>
        <b-table hover :items="itemsHistorial" :fields="fieldHistorial"
        style="max-width:648px;margin:auto" :empty-text="$t('reusables.empty-text')"/>
        <div class="empty" v-show="!itemsHistorial.length">
          <img src="@/assets/img/empty.png">
          <p>{{$t('historial.compras.text.1')}}</p>
        </div>
        <div class="text-center pb-4">
          <div v-if="isBusy">
            <b-spinner label="Busy"></b-spinner>
          </div>
          <b-button v-else v-show="showSeeMore" class="btn-collapse" @click="loadMoreRows" id="collapse-card">{{$t('reusables.load-more')}}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as tools from '@/assets/js/tools.js';
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';

  export default {
    data() {
      return {
        generalCourse:null,
        size: 6,
        pageSize: 10,
        isBusy: false,
        showSeeMore: false,
        optionsCourse:[
            { value: 'a', text: 'This is First option' },
        ],
        hePassed:0,
        section:0,
        fieldCompraActiva: [
          {key:'strPurchaseDate' , label: this.$t('historial.compras.table-th.1')},
          {key:'strExpirationDate' , label:this.$t('historial.compras.table-th.2')},
          {key:'name' , label: this.$t('historial.compras.table-th.3')},
          {key:'strPriceTotal', label: this.$t('historial.compras.table-th.4'), formatter: (v, k, i) => {return '$' + v;}}
        ],
        itemsCompraActiva: [],
        fieldHistorial: [
          {key:'strPurchaseDate' , label: this.$t('historial.compras.table-th.1')},
          {key:'strExpirationDate' , label: this.$t('historial.compras.table-th.2')},
          {key:'name' , label: this.$t('historial.compras.table-th.3')},
          {key:'strPriceTotal', label: this.$t('historial.compras.table-th.4'), formatter: (v, k, i) => {return '$' + v;}}
        ],
        itemsHistorial: []
      }
    },
    mounted(){
        //importante para los iconos, arriba esta la importación ----------------
        this.$nextTick(function () {
            tools.imgToSvg()
        });
        this.getGroupsPlanHistory();
    },
    methods:{
        goRevision(){
            this.$router.push("/student/evaluaciones/review")
        },
        loadMoreRows(){
          this.size += this.pageSize;//Hacer dianamico
          this.getGroupsPlanHistory(false);
        },
        getGroupsPlanHistory(isFirst = true){
          this.isBusy = true;
          
          let params = {
            //groupId: this.$store.state.group_id,
            idPersonStudent: this.$store.state.user.personStudentId,
            page: 1,
            size: this.size
          };

          baseInstanceAxios
            .get(this.apiURL + `/Resources/Groups/GetLitGroupsPlanHistory`, {params})
            .then(response => {
                if (response.data != null) {
                  if(response.data.entity && isFirst){
                    this.itemsCompraActiva = [response.data.entity];
                  }
                  this.showSeeMore = (response.data.rows > this.size);
                  this.itemsHistorial = response.data.list;
                }
                this.isBusy = false;
            });
        }
    }
  }
</script>